import { BaseResponse } from './base.response';
import { ShipVia } from '../models';

export class ShipViaResponse extends BaseResponse {

  public shipVias: ShipVia[];

}
